import { TranslationObject } from '@/types/language';

const englishTranslations: TranslationObject = {
  // Home Screen
  'welcome': 'Welcome to the Museum',
  'select_tour': 'Select a Tour',
  'search_exhibit': 'Search for an Exhibit',
  'visitor_info': 'Visitor Information',
  
  // Tour Selection
  'available_tours': 'Available Tours',
  'view_all_tours': 'View All Tours',
  
  // Exhibit Access
  'exhibit_access': 'Access an Exhibit',
  'enter_number': 'Enter Exhibit Number',
  'enter_exhibit_number': 'Enter an Exhibit Number',
  'scan_qr': 'Scan QR Code',
  'view_map': 'View on Map',
  'browse_exhibits': 'Browse Exhibits',
  'keypad': 'Keypad',
  'browse_tours': 'Browse Tours',
  
  // Exhibit Detail
  'add_to_favorites': 'Add to Favorites',
  'remove_from_favorites': 'Remove from Favorites',
  'share': 'Share',
  'previous': 'Previous',
  'next': 'Next',
  'audio_guide': 'Audio Guide',
  'more_info': 'More Information',
  'link_copied': 'Link copied to clipboard',
  'share_failed': 'Failed to share',
  
  // Favorites
  'favorites': 'Favorites',
  'no_favorites': 'No favorites yet. Add exhibits as you explore!',
  
  // Visitor Info
  'opening_hours': 'Opening Hours',
  'getting_here': 'Getting Here',
  'contact': 'Contact Us',
  'important_links': 'Important Links',
  
  // Accessibility
  'accessibility': 'Accessibility',
  'font_size': 'Font Size',
  'font_size_normal': 'Normal',
  'font_size_large': 'Large',
  'font_size_extra_large': 'X-Large',
  'high_contrast': 'High Contrast',
  'language': 'Language',
  'select_language': 'Select Language',
  'accessibility_menu': 'Accessibility options',
  'toggle_high_contrast': 'Toggle high contrast mode',
  'audio_controls': 'Audio Controls',
  'playback_speed': 'Playback Speed',
  'volume': 'Volume',
  'auto_play_audio': 'Auto Play Audio',
  'toggle_auto_play': 'Toggle auto play audio',
  
  // Navigation
  'home': 'Home',
  'tours': 'Tours',
  'exhibits': 'Exhibits',
  'info': 'Info',
  'map': 'Map',
  'list': 'List',
  
  // General
  'loading': 'Loading...',
  'error': 'Something went wrong',
  'back': 'Back',
  'play': 'Play',
  'pause': 'Pause',

  // Search related translations
  'search': 'Search...',
  'no_results': 'No results found',
  'exhibit': 'Exhibit',
  'not_found': 'not found',
  
  // Error Messages
  'no_exhibit_found_with_number': 'No exhibit found with number:',
  'unexpected_error': 'An unexpected error occurred',

  // Welcome Message
  'welcome_message': 'Welcome to The Agam Museum, Rishon LeZion.\nThe museum is the fruit of a joint initiative of the Rishon LeZion Municipality and the artist Yaakov Agam – a native of the city since its days as a young colony.\n\nThe museum is one of the few institutions in the world dedicated to kinetic art, and presents groundbreaking works from six decades of international artistic activity, which have been exhibited in renowned museums and collections around the world.\n\nAlongside the impressive permanent display of Agam\'s works, the museum offers temporary exhibitions that place his work in a living dialogue with the works of contemporary artists.\n\nThe museum sees utmost importance in encouraging artistic conversation, especially intergenerational and multigenerational, believing that this discussion enriches the cultural experience, deepens understanding, and connects the art world to contemporary and relevant contexts.',
  'welcome_message_title': 'Welcome',
};

export default englishTranslations;
